export const DYNAMIC_REACT_PORTAL_Z_INDEX_CLASS = 'z-index-dynamic-react-portal';
